import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './LoadingHome.css';

export default function LoadingHome({ onFinish }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(onFinish, 300);
          return 100;
        }
        return prev + Math.floor(Math.random() * 8) + 3;
      });
    }, 40);
    return () => clearInterval(interval);
  }, [onFinish]);

  return (
    <AnimatePresence>
      <motion.div
        className="loading-screen"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      >
        <div className="loading-inner">
          <motion.div
            className="loading-logo"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            COPAS<span>.</span>FILMS
          </motion.div>

          <div className="loading-bar-wrap">
            <div className="loading-bar-track">
              <motion.div
                className="loading-bar-fill"
                animate={{ width: `${Math.min(count, 100)}%` }}
                transition={{ ease: 'linear', duration: 0.04 }}
              />
            </div>
            <span className="loading-count">{Math.min(count, 100)}%</span>
          </div>

          <div className="loading-tag">INICIANDO TIMELINE</div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
